import React, { useState } from "react";
import {
  MenuItemData,
  UserMenuData,
} from "../../../utilities/menus/MenuStruct";
import MenuItem from "./MenuItem";
import { BsFillHexagonFill, BsGearFill } from "react-icons/bs";
import { MenuKeys } from "../../../utilities/menus/MenuKeys";
import { Assets } from "../../../assets";
import { userHasAuthorization } from "../../../utilities/helpers/permissions";
import { Popover } from "antd";
import { FaTruckFast } from "react-icons/fa6";

type AppMenuProps = {
  menus: UserMenuData;
  onMenuClick?: (menu: MenuItemData) => void;
  openMenu?: boolean;
  showMenuChild?: MenuItemData | null;
  activeMenu?: MenuItemData | null;
  userAuthorizedMenus?: Array<string>;
};

const AppMenu = ({
  menus,
  onMenuClick,
  openMenu,
  showMenuChild,
  activeMenu,
  userAuthorizedMenus,
}: AppMenuProps) => {
  const [openRight, setOpenRight] = useState<boolean>(false);
  const getIcon = (menu: MenuItemData) => {
    if (menu.title?.toLowerCase() === "Tableau de bord".toLowerCase()) {
      return <img src={Assets.iconsSvg.dashboard} width={"22px"} alt="icon" />;
    }
    if (menu.title?.toLowerCase() === "RH".toLowerCase()) {
      return <img src={Assets.iconsSvg.employee} width={"22px"} alt="icon" />;
    }
    if (menu.title?.toLowerCase() === "Paramètres".toLowerCase()) {
      return <img src={Assets.iconsSvg.setting} width={"22px"} alt="icon" />;
    }
    if (menu.title?.toLocaleLowerCase() === "Entreposage".toLocaleLowerCase()) {
      return (
        <img src={Assets.iconsSvg.entroposage} width={"22px"} alt="icon" />
      );
    }
    if (
      menu.title?.toLocaleLowerCase() ===
      "Gestion des clients"?.toLocaleLowerCase()
    ) {
      return <img src={Assets.iconsSvg.customer} width={"22px"} alt="icon" />;
    }
    if (menu.title?.toLocaleLowerCase() === "Transport"?.toLocaleLowerCase()) {
      return (
        <FaTruckFast
          style={{
            width: "22px",
            height: "22px",
          }}
        />
      );
    }
    if (
      menu.title?.toLocaleLowerCase() ===
      "Gestion des opérations"?.toLocaleLowerCase()
    ) {
      return <img src={Assets.iconsSvg.operation} width={"22px"} alt="icon" />;
    }
    if (menu.title?.toLocaleLowerCase() === "Matériels"?.toLocaleLowerCase()) {
      return <img src={Assets.iconsSvg.materials} width={"22px"} alt="icon" />;
    }
    if (
      menu.title?.toLocaleLowerCase() === "Tableau de bord"?.toLocaleLowerCase()
    ) {
      return <img src={Assets.iconsSvg.dashboard} width={"22px"} alt="icon" />;
    }
    return <BsFillHexagonFill color="#00000000" size={22} />;
  };
  const onClickMenu = (menu: MenuItemData) => {
    if (!onMenuClick) return;
    onMenuClick(menu);
  };
  // const userHasAuthorization = (userMenus: Array<string>, menu: string) => {
  //   console.log('Menu tio check : ', menu, userMenus)
  //   if (userMenus.includes(menu) || userMenus.includes('*')) {
  //     return true;
  //   }
  //   return false;
  // }
  return (
    <div className="px-2 py-4">
      {menus?.member?.map((menu, i) => {
        if (!menu.childrenToShow || !menu.childrenToShow.length) {
          // if (!MenuKeys[menu.routeName]) {
          //   return <div className="text-danger">Menu key undefined</div>
          // }
          // if( menu.childrenToShow.length ==0) {
          //   return <div>{menu.routeName}</div>
          // }
          if (
            !userAuthorizedMenus ||
            (userAuthorizedMenus &&
              !userHasAuthorization(userAuthorizedMenus, menu.routeName))
          ) {
            return "";
          }
          return (
            <MenuItem
              key={menu?.["@id"] + menu?.["@type"] + "_" + i}
              title={menu?.title}
              icon={getIcon(menu)}
              link={MenuKeys?.[menu?.routeName]?.routeName}
              children={[]}
              onClick={() => onClickMenu(menu)}
              level={0}
              active={
                activeMenu?.routeName !== undefined &&
                activeMenu?.routeName === menu?.routeName
              }
              openMenu={openMenu}
            />
          );
        } else if (menu.childrenToShow.length >= 0) {
          if (menu.childrenToShow?.length) {
            if (
              !menu.childrenToShow?.some((item) =>
                userHasAuthorization(
                  userAuthorizedMenus as any,
                  item?.routeName
                )
              )
            ) {
              return "";
            }
          }
          const menuBlock = (
            <div
              className="d-flex flex-column align-items-start "
              key={menu?.["@id"] + menu?.["@type"] + "_" + i}
            >
              <MenuItem
                title={menu.title}
                icon={getIcon(menu)}
                link={""}
                children={menu.childrenToShow}
                onClick={() => onClickMenu(menu)}
                level={0}
                opened={menu?.title === showMenuChild?.title}
                active={
                  (activeMenu?.routeName !== undefined &&
                    activeMenu?.routeName === menu?.routeName) ||
                  (!openMenu &&
                    menu?.childrenToShow?.find((r) => {
                      return r?.["@id"] === activeMenu?.["@id"];
                    }) !== undefined)
                }
                openMenu={openMenu}
              />
          
              {showMenuChild?.title === menu?.title && openMenu && (
                <div className="d-flex flex-column align-items-start w-100">
                  {menu?.childrenToShow?.map((childMenu, ic) => {
                    if (!MenuKeys[childMenu.routeName]) return null;
          
                    if (
                      !userAuthorizedMenus ||
                      !userHasAuthorization(userAuthorizedMenus, childMenu.routeName)
                    ) {
                      return null;
                    }
          
                    return (
                      <MenuItem
                        key={
                          childMenu?.["@id"] + menu?.["@type"] + "_child" + ic
                        }
                        title={childMenu.title}
                        icon={getIcon(childMenu)}
                        link={MenuKeys[childMenu.routeName].routeName}
                        children={[]}
                        onClick={() => onClickMenu(childMenu)}
                        level={1}
                        active={
                          activeMenu?.routeName === childMenu?.routeName
                        }
                        openMenu={openMenu}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          );
          if (openMenu) {
            return menuBlock; // Pas de popover
          }
          
          return (
            <Popover
              placement="right"
              //open={openRight}
              onOpenChange={(openedt) => {
                if (
                  showMenuChild?.title === menu?.title &&
                  openedt
                ) {
                  setOpenRight(true);
                } else {
                  setOpenRight(false);
                }
              }}
              trigger="hover"
              content={
                <div className="d-flex flex-column align-items-start w-100">
                  {menu?.childrenToShow?.map((childMenu, ic) => {
                    if (!MenuKeys[childMenu.routeName]) return null;
          
                    if (
                      !userAuthorizedMenus ||
                      !userHasAuthorization(userAuthorizedMenus, childMenu.routeName)
                    ) {
                      return null;
                    }
          
                    return (
                      <MenuItem
                        key={
                          childMenu?.["@id"] + menu?.["@type"] + "_child" + ic
                        }
                        title={childMenu.title}
                        icon={getIcon(childMenu)}
                        link={MenuKeys[childMenu.routeName].routeName}
                        children={[]}
                        onClick={() => onClickMenu(childMenu)}
                        level={1}
                        active={
                          activeMenu?.routeName === childMenu?.routeName
                        }
                        openMenu={true}
                      />
                    );
                  })}
                </div>
              }
            >
              {menuBlock}
            </Popover>
          );
        }
        return null;
      })}
    </div>
  );
};

export default AppMenu;
